import X2JS from 'x2js';

export function xmlToJs(xml: string): unknown {
  return new X2JS().xml2js(xml);
}
